import { getUnitName, unitLanguage } from "../../utils/unitNames";

const words = {
  es: { title: "Equivalencia definida", equals: "equivale a", of: "de", item: "este artículo" },
  en: { title: "Configured conversion", equals: "equals", of: "of", item: "this item" },
  ca: { title: "Equivalència definida", equals: "equival a", of: "de", item: "aquest article" },
};

// Inflect familiar labels only. Custom unit names/codes stay exactly as entered;
// the multiplication sign makes them readable without guessing their grammar.
const unitForms = {
  es: [
    ["botella", "botellas"], ["ampolla", "ampollas"], ["caja", "cajas"], ["unidad", "unidades"],
    ["paquete", "paquetes"], ["bolsa", "bolsas"], ["saco", "sacos"],
    ["kilogramo", "kilogramos"], ["gramo", "gramos"], ["litro", "litros"],
    ["mililitro", "mililitros"], ["lata", "latas"], ["bandeja", "bandejas"],
  ],
  en: [
    ["bottle", "bottles"], ["box", "boxes"], ["unit", "units"],
    ["pack", "packs"], ["bag", "bags"], ["case", "cases"], ["can", "cans"],
    ["kilogram", "kilograms"], ["gram", "grams"], ["liter", "liters"],
    ["litre", "litres"], ["milliliter", "milliliters"], ["millilitre", "millilitres"],
  ],
  ca: [
    ["ampolla", "ampolles"], ["caixa", "caixes"], ["unitat", "unitats"],
    ["paquet", "paquets"], ["bossa", "bosses"], ["llauna", "llaunes"],
  ],
};

export default function ItemSubunitPreview({ unitId, subunitId, factor, itemName, units = [], languageId }) {
  const unit = units.find((row) => String(row.id) === String(unitId));
  const subunit = units.find((row) => String(row.id) === String(subunitId));
  const quantity = Number(factor);
  if (!unitId || !subunitId || String(unitId) === String(subunitId) || !unit || !subunit ||
      !Number.isFinite(quantity) || quantity <= 0 || quantity > 99999999.99 || Number(quantity.toFixed(2)) !== quantity) return null;
  const language = unitLanguage(languageId), copy = words[language] || words.en;
  const formatter = new Intl.NumberFormat(language === "es" ? "es-ES" : language === "ca" ? "ca-ES" : "en-GB", { maximumFractionDigits: 2 });
  const quantityLabel = (value, selectedUnit) => {
    const label = getUnitName(selectedUnit, languageId);
    const forms = unitForms[language]?.find(pair => pair.includes(label.toLowerCase()));
    return `${formatter.format(value)} ${forms ? forms[value === 1 ? 0 : 1] : `× ${label}`}`;
  };
  if (!getUnitName(unit, languageId) || !getUnitName(subunit, languageId)) return null;
  return <div className="item-subunit-preview" role="status" aria-live="polite" aria-atomic="true">
    <span className="item-subunit-preview__label">{copy.title}</span>
    <strong className="item-subunit-preview__definition">
      {quantityLabel(1, unit)} {copy.equals} {quantityLabel(quantity, subunit)} {copy.of} {itemName?.trim() || copy.item}.
    </strong>
  </div>;
}
